// extracted by mini-css-extract-plugin
export default {"content":"RightSidebar_content__Eb5NZ"};